var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopySmall = function SvgCopySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M15.535 15.535h.261c2.91 0 4.205-1.295 4.205-4.205V8.205c0-2.91-1.295-4.205-4.205-4.205h-3.125C9.76 4 8.466 5.295 8.466 8.205v.26h-.261C5.295 8.465 4 9.76 4 12.67v3.125C4 18.705 5.295 20 8.205 20h3.125c2.91 0 4.205-1.295 4.205-4.205zm.261-1.116h-.26v-1.75c0-2.909-1.295-4.204-4.205-4.204H9.582v-.26c0-2.307.782-3.089 3.089-3.089h3.125c2.307 0 3.089.782 3.089 3.089v3.125c0 2.307-.782 3.089-3.089 3.089m-10.68-1.75c0-2.306.782-3.088 3.089-3.088h3.125c2.307 0 3.089.782 3.089 3.089v3.125c0 2.307-.782 3.089-3.089 3.089H8.205c-2.307 0-3.089-.782-3.089-3.089z",
    clipRule: "evenodd"
  })));
};
export default SvgCopySmall;